import Vue from 'vue';
import VueRouter from 'vue-router';
import scrollBehavior from './scrollBehavior';
Vue.use(VueRouter);

export const routes = [{
	path: '/',
	name: 'index',
	component: () => import('@/views/index/index'),
	meta: {
		isMobile: false
	}
}, {
	path: '/case',
	name: 'case',
	component: () => import('@/views/case/index'),
	meta: {
		isMobile: false
	}
}, {
	path: '/caseInfo',
	name: 'caseInfo',
	component: () => import('@/views/case/info'),
	meta: {
		isMobile: false
	}
}, {
	path: '/about',
	name: 'about',
	component: () => import('@/views/about/index'),
	meta: {
		isMobile: false
	}
}, {
	path: '/service',
	name: 'service',
	component: () => import('@/views/service/index'),
	meta: {
		isMobile: false
	}
}, {
	path: '/share',
	name: 'share',
	component: () => import('@/views/share/index'),
	meta: {
		isMobile: false
	}
}, {
	path: '/contact',
	name: 'contact',
	component: () => import('@/views/contact/index')
}, {
	path: '/mIndex',
	name: 'mIndex',
	component: () => import('@/views/mobile/index/index'),
	meta: {
		isMobile: true
	}
}, {
	path: '/mCase',
	name: 'mCase',
	component: () => import('@/views/mobile/case/index'),
	meta: {
		isMobile: true
	}
}, {
	path: '/mCaseInfo',
	name: 'mCaseInfo',
	component: () => import('@/views/mobile/case/info'),
	meta: {
		isMobile: true
	}
}]

const router = new VueRouter({
	mode: 'history', // 使用history模式
	base: process.env.BASE_URL,
	routes,
	scrollBehavior
});

router.beforeEach((to, from, next) => {
	let isMobile = /Mobi|Android/i.test(navigator.userAgent);
	if (isMobile && !to.meta.isMobile) {
		next({ path: '/mIndex' });
	} else if (!isMobile && to.meta.isMobile) {
		next({ path: '/' });
	} else {
		next();
	}
});

export default router;